import React from "react";
import {
  FiSearch,
  FiGrid,
  FiList,
  FiRotateCcw,
  FiGlobe,
  FiCheckCircle,
  FiUser,
} from "react-icons/fi";
import { PROPERTY_TABS } from "../constants/propertyEndpoints";
import "./PropertyFilterToolbar.css";

const PropertyFilterToolbar = ({
  activeTab,
  onTabChange,
  searchTerm,
  onSearchChange,
  onSearchSubmit,
  selectedType,
  onTypeChange,
  propertyTypes = [],
  selectedState,
  onStateChange,
  states = [],
  selectedCity,
  onCityChange,
  cities = [],
  onResetFilters,
  viewMode,
  onViewModeChange,
  showMyTab = true,
}) => {
  return (
    <div className="property-filter-toolbar">
      {/* Top row: Module Tabs */}
      <div className="property-filter-toolbar__tabs">
        <button
          type="button"
          className={`property-filter-tab ${
            activeTab === PROPERTY_TABS.ALL ? "property-filter-tab--active" : ""
          }`}
          onClick={() => onTabChange(PROPERTY_TABS.ALL)}
        >
          <FiGlobe className="property-filter-tab__icon" />
          <span>All Properties</span>
        </button>

        <button
          type="button"
          className={`property-filter-tab ${
            activeTab === PROPERTY_TABS.PREFERRED ? "property-filter-tab--active" : ""
          }`}
          onClick={() => onTabChange(PROPERTY_TABS.PREFERRED)}
        >
          <FiCheckCircle className="property-filter-tab__icon" />
          <span>Preferred (Partner)</span>
        </button>

        {showMyTab && (
          <button
            type="button"
            className={`property-filter-tab ${
              activeTab === PROPERTY_TABS.MY ? "property-filter-tab--active" : ""
            }`}
            onClick={() => onTabChange(PROPERTY_TABS.MY)}
          >
            <FiUser className="property-filter-tab__icon" />
            <span>My Properties</span>
          </button>
        )}
      </div>

      {/* Bottom row: Search + Select Dropdowns + View Switcher */}
      <div className="property-filter-toolbar__controls">
        {/* Search input form */}
        <form
          className="property-filter-toolbar__search"
          onSubmit={(e) => {
            e.preventDefault();
            if (onSearchSubmit) onSearchSubmit();
          }}
        >
          <FiSearch className="property-filter-toolbar__search-icon" />
          <input
            type="text"
            placeholder="Search property, title, location, builder..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="property-filter-toolbar__search-input"
          />
          {searchTerm && (
            <button
              type="button"
              className="property-filter-toolbar__clear-btn"
              onClick={() => onSearchChange("")}
            >
              ×
            </button>
          )}
        </form>

        {/* Filters Group */}
        <div className="property-filter-toolbar__selects">
          {/* Property Type */}
          <div className="property-filter-select-wrap">
            <select
              value={selectedType}
              onChange={(e) => onTypeChange(e.target.value)}
              className="property-filter-select"
            >
              <option value="">All Property Types</option>
              {propertyTypes.map((t) => {
                const name = typeof t === "object" ? t.name : t;
                const id = typeof t === "object" ? t.id || t.name : t;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* State */}
          <div className="property-filter-select-wrap">
            <select
              value={selectedState}
              onChange={(e) => onStateChange(e.target.value)}
              className="property-filter-select"
            >
              <option value="">All States</option>
              {states.map((s) => {
                const name = typeof s === "object" ? s.name : s;
                const id = typeof s === "object" ? s.id || s.name : s;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* City */}
          <div className="property-filter-select-wrap">
            <select
              value={selectedCity}
              onChange={(e) => onCityChange(e.target.value)}
              className="property-filter-select"
            >
              <option value="">All Cities</option>
              {cities.map((c) => {
                const name = typeof c === "object" ? c.name : c;
                const id = typeof c === "object" ? c.id || c.name : c;
                return (
                  <option key={id} value={name}>
                    {name}
                  </option>
                );
              })}
            </select>
          </div>

          {/* Reset button */}
          {(searchTerm || selectedType || selectedState || selectedCity) && (
            <button
              type="button"
              className="property-filter-reset-btn"
              onClick={onResetFilters}
              title="Reset Filters"
            >
              <FiRotateCcw size={14} />
              <span>Reset</span>
            </button>
          )}
        </div>

        {/* View mode toggle */}
        <div className="property-view-toggle">
          <button
            type="button"
            className={`property-view-toggle__btn ${
              viewMode === "grid" ? "property-view-toggle__btn--active" : ""
            }`}
            onClick={() => onViewModeChange("grid")}
            title="Grid View"
          >
            <FiGrid size={16} />
          </button>
          <button
            type="button"
            className={`property-view-toggle__btn ${
              viewMode === "table" ? "property-view-toggle__btn--active" : ""
            }`}
            onClick={() => onViewModeChange("table")}
            title="List / Table View"
          >
            <FiList size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertyFilterToolbar;
